import {
  Modal,
  Button,
} from "@mui/material"
import {
  ButtonWrapper,
  ModalCard,
  ModalContent,
  ModalHeader,
  Spacer,
} from "./SkipValidationModal.styles"

export default function SkipValidationModal({
  open,
  onClose,
  onSubmit,
}: {
  open: boolean
  onClose: () => void
  onSubmit: () => void
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalCard>
        <ModalHeader>
          You are about to submit this invoice, skipping the validation process
        </ModalHeader>
        <ModalContent>
          The invoice will be submitted for processing, but further validations
          will be skipped. This should be used to release stuck invoices, or
          other cases where further validations are not desired.
        </ModalContent>
        <ButtonWrapper>
          <Spacer />
          <Button
            variant="outlined"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onSubmit}
          >
            Submit
          </Button>
        </ButtonWrapper>
      </ModalCard>
    </Modal>
  )
}
